export const environment = {
  production: true,
  myBackend: "https://api.apps4artists.uk",
  stripe:
    "pk_live_51HFk4zJd3fzjfrRu7Rlrq6gDFX0uhuMD4e6r0urJtHioSvL0knYulOQuEnXctbOzRAdvf9PZ7JdnZ8lTRUTWtOnF00CrTxPVVu",
  firebaseConfig: {
    apiKey: "AIzaSyBIQnzkxzM4aW7AU7ANo7rS4jpC47K2DlE",
    authDomain: "apps4artists.firebaseapp.com",
    projectId: "apps4artists",
    storageBucket: "apps4artists.appspot.com",
    messagingSenderId: "97703493798",
    appId: "1:97703493798:web:c588d911f68d6df3eeb467",
    measurementId: "G-7SWVBF6RBC",
  },
};
